module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"power":"Total","power0":"L0","power1":"L1","power2":"L2","power3":"L3"},"de":{"power":"Total","power0":"L0","power1":"L1","power2":"L2","power3":"L3"},"fr":{"power":"Total","power0":"L0","power1":"L1","power2":"L2","power3":"L3"},"it":{"power":"Totalmente","power0":"L0","power1":"L1","power2":"L2","power3":"L3"}}')
  delete Component.options._Ctor
}
